import { Link } from "react-router-dom";
import { Sparkles } from "lucide-react";
import { adminAuth } from "@/lib/api";
import { editionFor, PRODUCT_NAME } from "@/lib/kcisEdition";

/**
 * Brand chip in the top-left of every page.
 *
 * Phase 6A — shows "KCIS™" plus the practitioner's Edition below when:
 *  - the admin is signed in
 *  - and their subscription_tier maps to a known Edition string (Lite / Pro / Clinical / Enterprise)
 *
 * super_admin and signed-out / public visitors see just "KCIS™" with no second line.
 * RBAC is NOT enforced here — this is display-only.
 */
export const Logo = ({ className = "" }) => {
  const tier = adminAuth.getEdition();          // localStorage; "" when signed out
  const role = adminAuth.getRole();
  const editionLabel = role === "super_admin" ? null : editionFor(tier);
  return (
    <Link to="/" className={`flex items-center gap-2 ${className}`} data-testid="kcis-logo">
      <div className="h-9 w-9 rounded-xl bg-purple-900 flex items-center justify-center text-white shadow-sm">
        <Sparkles className="h-4 w-4" />
      </div>
      <div className="leading-tight">
        <div className="font-display font-semibold tracking-tight text-slate-900 text-base" data-testid="kcis-brand-chip">
          {PRODUCT_NAME}
        </div>
        {editionLabel ? (
          <div className="kcis-overline text-[0.55rem]" data-testid="kcis-brand-chip-edition">{editionLabel}</div>
        ) : null}
      </div>
    </Link>
  );
};

export const TopNav = ({ right = null }) => (
  <header className="kcis-glass sticky top-0 z-50">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-16 flex items-center justify-between">
      <Logo />
      <div className="flex items-center gap-3">{right}</div>
    </div>
  </header>
);

export const Footer = () => (
  <footer className="border-t border-slate-200 bg-white/60 mt-24">
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-10 flex flex-col md:flex-row gap-4 items-start md:items-center justify-between">
      <div>
        <div className="font-display font-semibold text-slate-900">KISSED Clinic OS</div>
        <p className="text-sm text-slate-500 mt-1 max-w-md">KISSED Trichology &amp; Functional Wellness Clinic. Educational wellness support. Not a substitute for licensed medical care.</p>
      </div>
      <div className="kcis-overline">© {new Date().getFullYear()} KISSED Clinic OS</div>
    </div>
  </footer>
);
